import { toast } from "react-toastify";
import { t } from "i18next"; // Adjust translation method as needed
import ErrorToast from "@components/Common/ErrorTost";
import { GetSalesModesTypesAndTagsV2 } from "./helper";
import {
    archiveModeOfSaleFranchise,
    archiveModeSale,
    associateModeOfSaleCustomIcons,
} from "./modeOfSaleCheckers";

export async function isModeOfSaleUsed(
    userID: any,
    shopId: any,
    franchiseID: any,
    modeOfSaleId: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    toast.dismiss();
    let isModeOfSaleUsed = false;
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/isModeOfSaleUsed?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&modeOfSale=${modeOfSaleId}`;

    try {
        const result = await fetchGlobal<any>(url, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (result.modeOfSaleUsed.length > 0) {
            isModeOfSaleUsed = true;
            ErrorToast(t("Attention, you cannot archive a used element."));
        }
    } catch (error) {
        ErrorToast(`${t("There's an error")!}`);
    }

    return isModeOfSaleUsed;
}

export async function isSaleSupportArchived(
    userID: any,
    shopId: any,
    franchiseID: any,
    saleSupport: any,
    i18nextLng: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    toast.dismiss();
    let isSaleSupportArchived = false;
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=archived`;

    try {
        const data = await fetchGlobal<any>(url, {
            method: "GET",
            headers: { "Accept-Language": i18nextLng },
        });

        data.data.forEach((elt: any) => {
            if (saleSupport.includes(elt[t("Sale support")])) {
                isSaleSupportArchived = true;
            }
        });
    } catch (error) {
        ErrorToast(`${t("There's an error")!}`);
    }

    return isSaleSupportArchived;
}

export async function isModeOfSaleConsumed(
    shopId: any,
    franchiseID: any,
    modeOfSaleId: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    toast.dismiss();
    let isModeOfSaleUsed = false;
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/consumedSettingGeneral?shopId=${shopId}&franchiseId=${franchiseID}&type=salesMethods`;

    try {
        const result = await fetchGlobal<any>(url, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (result.data.some((el: any) => el.id === modeOfSaleId)) {
            isModeOfSaleUsed = true;
        }
    } catch (error) {
        ErrorToast(`${t("There's an error")!}`);
    }

    return isModeOfSaleUsed;
}

export async function handleAddSalesMethodClick(
    franchiseID: any,
    shopId: any,
    setSalesModesTypesAndTag: any,
    setModalState: any,
    setLocalFilterActive: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        const configs = await GetSalesModesTypesAndTagsV2(
            franchiseID,
            shopId,
            fetchGlobal
        );
        const data = configs[0];

        if (!data) return;

        setSalesModesTypesAndTag(data);
        setModalState((prev: any) => ({
            ...prev,
            isAddModeOfSaleClicked: true,
        }));

        setLocalFilterActive(false);
    } catch (error) {
        console.error("Error fetching sales modes and tags:", error);
    }
}

export function getDataForAssociationAndArchive(
    oneShop: boolean,
    shopsModeSaleData: any[],
    archivedModeOfSaleFranchise: any[],
    e: any
) {
    let dataAssociate: any[] = [];
    let dataArchive: any[] = [];

    if (!oneShop) {
        dataAssociate = associateModeOfSaleCustomIcons(
            shopsModeSaleData,
            e.selectedRow
        );
        dataArchive = archiveModeSale(shopsModeSaleData);
    } else {
        dataArchive = archiveModeOfSaleFranchise(archivedModeOfSaleFranchise);
    }

    return { dataAssociate, dataArchive };
}
